import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { Mermaid } from 'backstage-plugin-techdocs-addon-mermaid';
import elkLayouts from '@mermaid-js/layout-elk';

/**
 * TechDocs Mermaid addon wired for the new frontend system, with the ELK
 * layout loader registered so diagrams using `config: { layout: elk }`
 * frontmatter render with ELK instead of silently falling back to dagre.
 *
 * The stock `techDocsMermaidAddonModule` from the addon package does not pass
 * `layoutLoaders`, so we rebuild the addon via AddonBlueprint to inject ELK.
 * Do NOT also register the stock module — that would double-register Mermaid.
 */
const mermaidElkAddon = AddonBlueprint.make({
  name: 'mermaid',
  params: {
    name: 'Mermaid',
    location: 'Content',
    component: () => <Mermaid layoutLoaders={elkLayouts} />,
  },
});

export const techDocsMermaidModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [mermaidElkAddon],
});
